import styled from 'styled-components';

export const SkipToMainContentAnchor = styled.a`
  width: ${props => props.theme.space['14.4']};
  height: ${props => props.theme.space.s8};
  background-color: ${props => props.theme.colors.capsuleBlue30};
  opacity: ${props => props.theme.opacities.overlay};
  box-shadow: ${props => props.theme.shadows.dp24};
  color: ${props => props.theme.colors.white} !important;
  position: absolute;
  top: ${props => props.theme.space['8.7']};
  z-index: ${props => props.theme.zIndices.overlayEverything};
  padding-left: ${props => props.theme.space['2.5']};
  padding-top: ${props => props.theme.space['1.0']};
  transform: translateX(-200%);

  &:focus {
    transform: translateX(0);
  }
`;
